// Tiny hash-based router. Each route = { path: RegExp, render(ctx): HTMLElement }.
// Keeps us off Cloudflare SPA-redirects for v1.

export function createRouter(routes, mountEl) {
  let currentCleanup = null;

  async function render() {
    const hash = window.location.hash.replace(/^#/, '') || '/';
    const [pathOnly, queryStr = ''] = hash.split('?');
    const query = Object.fromEntries(new URLSearchParams(queryStr));

    for (const route of routes) {
      const m = pathOnly.match(route.path);
      if (!m) continue;
      if (currentCleanup) { try { currentCleanup(); } catch {} currentCleanup = null; }
      mountEl.innerHTML = '';
      const out = await route.render({ params: m.groups ?? {}, query, path: pathOnly });
      if (out instanceof HTMLElement) {
        mountEl.appendChild(out);
      } else if (out && typeof out === 'object' && 'el' in out) {
        mountEl.appendChild(out.el);
        if (typeof out.cleanup === 'function') currentCleanup = out.cleanup;
      }
      return;
    }
    mountEl.innerHTML = `<p class="p-8 text-stone-500">Route not found: ${pathOnly}</p>`;
  }

  window.addEventListener('hashchange', render);
  render();

  return {
    go(path) {
      window.location.hash = path;
    },
  };
}

export function navigate(path) {
  window.location.hash = path;
}
